import { FirebaseFirestore } from "@capacitor-firebase/firestore";
import { db } from "../firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import {
  getPlatform,
  isNativeFirestorePlatform,
  extractNativeDocumentData,
  removeNativeSnapshotListener,
} from "./firestorePlatform";

const FOOTER_COLLECTION = "footerTexte";
const FOOTER_DOC_ID = "main";
const FOOTER_REFERENCE = `${FOOTER_COLLECTION}/${FOOTER_DOC_ID}`;

const normalizeFooterData = (data) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return {};
  }
  return data;
};

const getFooterTextsViaWebSdk = async () => {
  console.log("🟢 getFooterTextsViaWebSdk START");

  const docRef = doc(db, FOOTER_COLLECTION, FOOTER_DOC_ID);
  const docSnap = await getDoc(docRef);

  console.log("🟢 getFooterTextsViaWebSdk RESULT", {
    exists: docSnap.exists(),
    data: docSnap.exists() ? docSnap.data() : null,
  });

  if (!docSnap.exists()) {
    throw new Error("Footer-Dokument nicht gefunden");
  }

  return normalizeFooterData(docSnap.data());
};

const getFooterTextsViaNativeFirestore = async () => {
  console.log("🟢 getFooterTextsViaNativeFirestore START", {
    platform: getPlatform(),
    reference: FOOTER_REFERENCE,
  });

  const result = await FirebaseFirestore.getDocument({
    reference: FOOTER_REFERENCE,
  });

  const data = normalizeFooterData(extractNativeDocumentData(result));

  console.log("🟢 getFooterTextsViaNativeFirestore RESULT", {
    raw: result,
    parsed: data,
  });

  return data;
};

export const getFooterTexts = async () => {
  try {
    if (isNativeFirestorePlatform()) {
      console.log("🟢 Footer data source: Native Firestore");
      return await getFooterTextsViaNativeFirestore();
    }

    console.log("🟢 Footer data source: Firestore Web SDK");
    return await getFooterTextsViaWebSdk();
  } catch (error) {
    console.error("🟢 getFooterTexts FAILED", {
      platform: getPlatform(),
      name: error?.name || null,
      message: error?.message || null,
      stack: error?.stack || null,
      full: error,
    });
    throw error;
  }
};

export const subscribeToFooterTexts = async (onData, onError) => {
  console.log("🟢 subscribeToFooterTexts START", {
    platform: getPlatform(),
    reference: FOOTER_REFERENCE,
  });

  if (isNativeFirestorePlatform()) {
    const callbackId = await FirebaseFirestore.addDocumentSnapshotListener(
      {
        reference: FOOTER_REFERENCE,
      },
      (event, error) => {
        if (error) {
          console.error("🟢 Native footer listener ERROR", error);
          if (typeof onError === "function") onError(error);
          return;
        }

        const data = normalizeFooterData(extractNativeDocumentData(event));

        console.log("🟢 Native footer listener EVENT", {
          raw: event,
          parsed: data,
        });

        if (typeof onData === "function") onData(data);
      }
    );

    return async () => {
      await removeNativeSnapshotListener(callbackId);
    };
  }

  const docRef = doc(db, FOOTER_COLLECTION, FOOTER_DOC_ID);

  const unsubscribe = onSnapshot(
    docRef,
    (docSnap) => {
      const data = docSnap.exists() ? normalizeFooterData(docSnap.data()) : {};

      console.log("🟢 Web footer listener EVENT", {
        exists: docSnap.exists(),
        data,
      });

      if (typeof onData === "function") onData(data);
    },
    (error) => {
      console.error("🟢 Web footer listener ERROR", error);
      if (typeof onError === "function") onError(error);
    }
  );

  return () => {
    unsubscribe();
    console.log("🟢 Web footer listener removed");
  };
};